import { render, staticRenderFns } from "./TurnPerDay.vue?vue&type=template&id=2e66b918&"
import script from "./TurnPerDay.vue?vue&type=script&lang=js&"
export * from "./TurnPerDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports